var XVISION_FMI4 = {
	name: "FMI4",
	defaultCommandIndex: 1,
	commands: [
		{
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [103,0,5,87,2,86,7,1,16,33,15,57,2,144,3,61,2,148,32,61,2,0,0,124,153,153,36,156,204,197,242,102,100,146,115,51,8],
            // command: [68,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,189,245,106,162],
        },
		{
            function: "TV_TV",
            name: "TV",
            icon: "tv_tv",
			command: [103,0,5,33,2,144,7,23,2,168,3,216,15,80,15,33,2,178,32,22,2,0,0,62,189,170,186,182,39,215,181,87,86,194],
        },
		{
            function: "TV_USB",
            name: "USB",
            icon: "tv_usb",
			command: [103,0,5,61,2,120,7,39,2,156,3,250,15,54,15,35,2,169,32,50,2,0,0,62,170,181,87,246,39,213,86,170,254,194],
        },
		{
            function: "TV_NUM_0",
            name: "0",
            icon: "tv_num_0",
			command: [103,0,5,61,2,115,7,76,2,124,3,255,15,36,15,65,2,148,32,49,2,0,0,62,186,170,174,190,39,215,85,85,215,194],
        },
		{
            function: "TV_NUM_1",
            name: "1",
            icon: "tv_num_1",
			command: [103,0,5,77,2,95,7,46,2,145,3,7,16,37,15,108,2,105,32,112,2,0,0,62,186,181,93,122,39,215,86,171,175,66],
        },
		{
            function: "TV_NUM_2",
            name: "2",
            icon: "tv_num_2",
			command: [103,0,5,65,2,121,7,42,2,141,3,237,15,52,15,40,2,156,32,43,2,0,0,62,186,213,93,118,39,215,90,171,174,194],
        },
		{
            function: "TV_NUM_3",
            name: "3",
            icon: "tv_num_3",
			command: [103,0,5,101,2,103,7,47,2,137,3,9,16,1,15,107,2,107,32,105,2,0,0,62,186,234,186,234,39,215,93,87,93,66],
        },
		{
            function: "TV_NUM_4",
            name: "4",
            icon: "tv_num_4",
			command: [103,0,5,85,2,96,7,47,2,134,3,1,16,34,15,51,2,121,32,61,2,0,0,62,187,85,93,110,39,215,106,171,173,194],
        },
		{
            function: "TV_NUM_5",
            name: "5",
            icon: "tv_num_5",
			command: [103,0,5,76,2,101,7,50,2,143,3,15,16,50,15,97,2,107,32,113,2,0,0,62,187,106,186,218,39,215,109,87,91,66],
        },
		{
            function: "TV_NUM_6",
            name: "6",
            icon: "tv_num_6",
			command: [103,0,5,64,2,105,7,45,2,145,3,241,15,55,15,44,2,148,32,47,2,0,0,62,187,170,186,214,39,215,117,87,90,194],
        },
		{
            function: "TV_NUM_7",
            name: "7",
            icon: "tv_num_7",
			command: [103,0,5,77,2,92,7,62,2,132,3,7,16,42,15,108,2,107,32,112,2,0,0,62,187,213,117,170,39,215,122,174,181,66],
        },
		{
            function: "TV_NUM_8",
            name: "8",
            icon: "tv_num_8",
			command: [103,0,5,56,2,120,7,50,2,140,3,246,15,56,15,43,2,163,32,47,2,0,0,62,189,85,93,94,39,215,170,171,171,194],
        },
		{
            function: "TV_NUM_9",
            name: "9",
            icon: "tv_num_9",
			command: [103,0,5,90,2,87,7,71,2,119,3,25,16,27,15,115,2,105,32,121,2,0,0,62,189,106,186,186,39,215,173,87,87,66],
        },
		{
            function: "TV_HISTORY",
            name: "History",
            icon: "tv_history",
			command: [103,0,5,35,2,150,7,25,2,167,3,225,15,77,15,37,2,178,32,35,2,0,0,63,175,85,87,86,39,245,234,170,234,194],
        },
		{
            function: "KEY_SOURCE",
            name: "Source",
            icon: "tv_source",
			command: [103,0,5,43,2,131,7,31,2,160,3,231,15,68,15,90,2,133,32,91,2,0,0,63,106,234,173,234,39,237,93,85,189,66],
        },
		{
            function: "KEY_VOLUMEUP",
            name: "Volume Up",
            icon: "tv_vol_up",
			command: [103,0,5,97,2,89,7,70,2,135,3,243,15,25,15,85,2,132,32,95,2,0,0,62,183,213,118,170,39,214,250,174,213,66],
        },
		{
            function: "KEY_VOLUMEDOWN",
            name: "Volume Down",
            icon: "tv_vol_down",
			command: [103,0,5,62,2,101,7,55,2,140,3,241,15,60,15,44,2,164,32,47,2,0,0,62,183,170,187,86,39,214,245,87,106,194],
        },
		{
            function: "KEY_CHANNELUP",
            name: "Channel Up",
            icon: "tv_ch_up",
			command: [103,0,5,62,2,97,7,46,2,145,3,247,15,58,15,103,2,106,32,109,2,0,0,62,183,106,187,90,39,214,237,87,107,66],
        },
		{
            function: "KEY_CHANNELDOWN",
            name: "Channel Down",
            icon: "tv_ch_down",
			command: [103,0,5,35,2,143,7,24,2,166,3,224,15,81,15,25,2,175,32,25,2,0,0,62,183,85,93,174,39,214,234,171,181,194],
        },
		{
            function: "KEY_MUTE",
            name: "Mute",
            icon: "tv_mute",
			command: [103,0,5,49,2,113,7,35,2,152,3,240,15,67,15,87,2,139,32,93,2,0,0,62,191,170,234,170,39,215,245,93,85,66],
        },
		{
            function: "TV_i",
            name: "i",
            icon: "tv_i",
			command: [103,0,5,51,2,135,7,26,2,163,3,225,15,71,15,26,2,181,32,25,2,0,0,62,190,170,186,174,39,215,213,87,85,194],
        },
		{
            function: "TV_APP",
            name: "APP",
            icon: "tv_app",
			command: [103,0,5,37,2,149,7,25,2,167,3,223,15,78,15,24,2,170,32,36,2,0,0,63,183,85,86,214,39,246,234,170,218,194],
        },
		{
            function: "TV_HOME",
            name: "HOME",
            icon: "tv_home",
			command: [103,0,5,81,2,95,7,75,2,125,3,253,15,55,15,89,2,129,32,89,2,0,0,62,171,85,87,222,39,213,106,170,251,194],
        },
		{
            function: "TV_EPG",
            name: "EPG",
            icon: "tv_epg",
			command: [103,0,5,59,2,122,7,25,2,167,3,238,15,58,15,23,2,180,32,37,2,0,0,62,174,213,94,182,39,213,218,171,214,194],
        },
		{
            function: "KEY_MENU",
            name: "Menu",
            icon: "tv_menu",
			command: [103,0,5,71,2,79,7,49,2,143,3,248,15,52,15,102,2,107,32,112,2,0,0,63,94,213,93,90,39,235,218,171,171,66],
        },
		{
            function: "KEY_UP",
            name: "Arrow Up",
            icon: "tv_arrow_up",
			command: [103,0,5,69,2,103,7,71,2,132,3,240,15,59,15,105,2,116,32,95,2,0,0,62,221,106,182,186,39,219,173,86,215,66],
        },
		{
            function: "KEY_LEFT",
            name: "Arrow Left",
            icon: "tv_arrow_left",
			command: [103,0,5,42,2,146,7,24,2,167,3,218,15,77,15,25,2,176,32,25,2,0,0,62,219,170,182,214,39,219,117,86,218,194],
        },
		{
            function: "KEY_DOWN",
            name: "Arrow Down",
            icon: "tv_arrow_down",
			command: [103,0,5,39,2,144,7,25,2,168,3,224,15,80,15,25,2,175,32,33,2,0,0,62,221,85,91,94,39,219,170,171,107,194],
        },
		{
            function: "KEY_RIGHT",
            name: "Arrow Right",
            icon: "tv_arrow_right",
			command: [103,0,5,36,2,148,7,24,2,171,3,217,15,82,15,47,2,174,32,38,2,0,0,62,219,213,109,170,39,219,122,173,181,66],
        },
		{
            function: "KEY_OK",
            name: "OK",
            icon: "tv_ok",
			command: [103,0,5,43,2,142,7,24,2,168,3,239,15,64,15,23,2,178,32,25,2,0,0,63,237,85,85,110,39,253,170,170,173,194],
        },
		{
            function: "KEY_BACK",
            name: "Return",
            icon: "tv_return",
			command: [103,0,5,38,2,144,7,24,2,167,3,214,15,89,15,103,2,124,32,100,2,0,0,62,181,234,187,170,39,214,189,87,117,66],
        },
		{
            function: "TV_EXIT",
            name: "EXIT",
            icon: "tv_exit",
			command: [103,0,5,62,2,107,7,66,2,147,3,252,15,61,15,57,2,165,32,58,2,0,0,62,170,234,175,214,39,213,93,85,250,194],
        },
		{
            function: "TV_ZOOM_OUT",
            name: "Zoom Out",
            icon: "tv_zoom_out",
			command: [103,0,5,53,2,116,7,56,2,145,3,252,15,62,15,38,2,144,32,41,2,0,0,63,253,85,85,86,39,255,170,170,170,194],
        },
		{
            function: "TV_ZOOM_IN",
            name: "Zoom In",
            icon: "tv_zoom_in",
			command: [103,0,5,34,2,144,7,27,2,156,3,218,15,80,15,34,2,185,32,24,2,0,0,63,95,85,93,86,39,235,234,171,170,194],
        },
		{
            function: "TV_TEXT",
            name: "TEXT",
            icon: "tv_text",
			command: [103,0,5,27,2,155,7,24,2,167,3,254,15,90,15,32,2,185,32,25,2,0,0,62,175,170,189,86,39,213,245,87,170,194],
        },
		{
            function: "TV_SLEEP",
            name: "Sleep",
            icon: "tv_sleep",
			command: [103,0,5,32,2,149,7,24,2,167,3,217,15,79,15,63,2,170,32,54,2,0,0,62,170,245,95,170,39,213,94,171,245,66],
        },
		{
            function: "TV_PRE_CH",
            name: "PRE-CH",
            icon: "tv_pre_ch",
			command: [103,0,5,49,2,128,7,33,2,165,3,229,15,67,15,32,2,178,32,44,2,0,0,63,190,170,173,86,39,247,213,85,170,194],
        },
		{
            function: "TV_FAV",
            name: "FAV",
            icon: "tv_fav",
			command: [103,0,5,48,2,126,7,24,2,161,3,234,15,73,15,104,2,109,32,105,2,0,0,62,170,218,175,218,39,213,91,85,251,66],
        },
		{
            function: "TV_LIST",
            name: "LIST",
            icon: "tv_list",
			command: [103,0,5,66,2,107,7,50,2,141,3,238,15,53,15,111,2,101,32,110,2,0,0,62,234,181,90,250,39,221,86,171,95,66],
        },
		{
            function: "TV_RED",
            name: "RED",
            icon: "tv_red",
			command: [103,0,5,57,2,120,7,53,2,146,3,246,15,55,15,51,2,154,32,54,2,0,0,62,170,170,171,254,39,213,85,85,127,194],
        },
		{
            function: "TV_GREEN",
            name: "GREEN",
            icon: "tv_green",
			command: [103,0,5,55,2,125,7,29,2,165,3,239,15,56,15,36,2,173,32,45,2,0,0,63,218,170,170,222,39,251,85,85,91,194],
        },
		{
            function: "TV_YELLOW",
            name: "YELLOW",
            icon: "tv_yellow",
			command: [103,0,5,73,2,117,7,45,2,149,3,234,15,43,15,37,2,168,32,39,2,0,0,63,214,170,170,238,39,250,213,85,93,194],
        },
		{
            function: "TV_BLUE",
            name: "BLUE",
            icon: "tv_blue",
			command: [103,0,5,35,2,147,7,25,2,170,3,225,15,78,15,25,2,177,32,24,2,0,0,63,186,170,171,94,39,247,85,85,107,194],
        },
		{
            function: "TV_LANG",
            name: "LANG",
            icon: "tv_lang",
			command: [103,0,5,41,2,135,7,39,2,161,3,221,15,86,15,44,2,183,32,61,2,0,0,63,191,85,90,170,39,247,234,171,85,66],
        },
		{
            function: "TV_REC",
            name: "REC",
            icon: "tv_rec",
			command: [103,0,5,31,2,143,7,30,2,167,3,219,15,87,15,43,2,177,32,52,2,0,0,62,173,234,189,170,39,213,189,87,181,66],
        },
		{
            function: "TV_SUBTITLE",
            name: "SUBTITLE",
            icon: "tv_subtitle",
			command: [103,0,5,35,2,141,7,29,2,167,3,226,15,81,15,26,2,179,32,47,2,0,0,63,85,85,85,254,39,234,170,170,191,194],
        },
		{
            function: "TV_PLAYBACK_PREV",
            name: "Prev",
            icon: "tv_playback_prev",
			command: [103,0,5,34,2,143,7,25,2,169,3,221,15,81,15,26,2,178,32,32,2,0,0,63,123,85,90,182,39,239,106,171,86,194],
        },
		{
            function: "TV_PLAYBACK_PLAY",
            name: "PLAY",
            icon: "tv_playback_play",
			command: [103,0,5,40,2,148,7,24,2,168,3,222,15,76,15,66,2,161,32,60,2,0,0,62,173,181,94,218,39,213,182,171,219,66],
        },
		{
            function: "TV_PLAYBACK_PAUSE",
            name: "Pause",
            icon: "tv_playback_pause",
			command: [103,0,5,80,2,95,7,82,2,120,3,19,16,46,15,103,2,108,32,94,2,0,0,62,174,181,94,186,39,213,214,171,215,66],
        },
		{
            function: "TV_PLAYBACK_NEXT",
            name: "Next",
            icon: "tv_playback_next",
			command: [103,0,5,33,2,148,7,24,2,165,3,241,15,87,15,63,2,162,32,56,2,0,0,62,218,234,182,234,39,219,93,86,221,66],
        },
		{
            function: "TV_PLAYBACK_FORWARD",
            name: "Forward",
            icon: "tv_playback_forward",
			command: [103,0,5,45,2,137,7,39,2,162,3,223,15,68,15,47,2,179,32,49,2,0,0,62,175,85,94,174,39,213,234,171,213,194],
        },
		{
            function: "TV_PLAYBACK_REWIND",
            name: "Rewind",
            icon: "tv_playback_rewind",
			command: [103,0,5,38,2,152,7,24,2,160,3,224,15,77,15,75,2,152,32,51,2,0,0,62,175,106,189,90,39,213,237,87,171,66],
        },
		{
            function: "TV_PLAYBACK_STOP",
            name: "STOP",
            icon: "tv_playback_stop",
			command: [103,0,5,36,2,140,7,29,2,166,3,220,15,85,15,92,2,157,32,61,2,0,0,62,175,213,122,170,39,213,250,175,85,66],
        },
    ]
}

export default XVISION_FMI4